var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: "imgs-slide imgs-slide-".concat(_vm.random)
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.srcs, function (src) {
    return _c('div', {
      key: src,
      staticClass: "swiper-slide"
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 1200 / 675
      }
    }, [_c('img', _vm._b({
      staticClass: "d-block",
      staticStyle: {
        "object-fit": "cover"
      },
      attrs: {
        "width": "100%",
        "height": "100%"
      }
    }, 'img', {
      src: src
    }, false))])], 1);
  }), 0), _vm._m(0)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-control"
  }, [_c('button', {
    staticClass: "swiper-prev"
  }, [_c('i', {
    staticClass: "icon icon-left-arrow-circle"
  })]), _c('button', {
    staticClass: "swiper-next"
  }, [_c('i', {
    staticClass: "icon icon-right-arrow-circle"
  })])]);
}]

export { render, staticRenderFns }